import type { ProfileFlags as ProfileFlagsType } from './ProfileTypes';
import { ProfileFlags } from './ProfileTypes';

export const isKycRequired = (profileFlags: ProfileFlagsType[] = []): boolean =>
    profileFlags.includes(ProfileFlags.KYC_QUESTIONNAIRE_REQUIRED);

export const isKycUpdateRequested = (profileFlags: ProfileFlagsType[] = []): boolean =>
    profileFlags.includes(ProfileFlags.KYC_QUESTIONNAIRE_REQUESTED) && !isKycRequired(profileFlags);
